/** @todo remove this file and change its references on project with contexts/User.context */
import UserProvider, { UserContext as UContext } from "contexts/User.context";

export const UserContext = UContext;

export default UserProvider;
